import { cn } from "~/lib/utils";
import { Button } from "./ui/button";
import { RichTextRenderer } from "~/components/RichTextRenderer";

export const CtaWide = ({
  align = "left",
  title,
  description,
  image,
  link1,
  link2,
  ctaLabel1,
  ctaLabel2,
  ctaLabelColor1 = "primary",
}: {
  align?: "left" | "center";
  title: string;
  description: string;
  image: string;
  link1: string;
  link2: string;
  ctaLabel1: string;
  ctaLabel2: string;
  ctaLabelColor1?: string;
}) => {
  return (
    <div className="relative py-20 layout-place-full-width">
      <img
        src={image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover z-0 "
      />
      <div className="layout-content-grid">
        <div className="bg-[#060606]/50 text-white relative z-10 md:max-w-1/2 p-16 rounded-md flex flex-col justify-center">
          <h2
            className={cn(
              "font-medium text-3xl sm:text-5xl",
              align === "center" ? "text-center" : "",
            )}
          >
            {title}
          </h2>
          <RichTextRenderer
            additionalClasses={cn(
              "mt-6 text-lg",
              align === "center" ? "text-center" : "",
            )}
            richText={description}
          />
          <div
            className={cn(
              "pt-6 flex gap-4",
              align === "center" ? "justify-center" : "",
            )}
          >
            <Button
              variant={ctaLabelColor1 === "black" ? "black" : "default"}
              size="lg"
            >
              {ctaLabel1}
            </Button>
            {link2 && ctaLabel2 && (
              <Button size="lg" variant="outlineWhite">
                <a href={link2}>{ctaLabel2}</a>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
